import pages from '@/store/modules/cms/pages'
import components from '@/store/modules/cms/components'

const modules = {
  pages,
  components
}

export default {
  namespaced: true,
  modules
}
